//@ts-check

class PersonalDocumentsService {
	constructor($http, Utility, $timeout, $rootScope, ContentService, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.personalDocumentsData = null;
		this.InternalLinksService.getLinks('/api/documents/links');
	}

	async getPersonalDocuments(schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!schemeRef) {
				throw 'No Building reference provided...';
			}

			let url = await this.InternalLinksService.getLink('GetWebPersonalDocuments');

			if (!url) {
				await this.InternalLinksService.getLinks('api/documents/links', false);
				url = await this.InternalLinksService.getLink('GetWebPersonalDocuments');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();

			const headers = this.Utility.headersWithContentType;
			const results = await this.$http.get(url, { headers });
			this.personalDocumentsData = results.data;
			this.$timeout(() => promiseHandler.resolve(this.personalDocumentsData));
		} catch (err) {
			const msg = `Error while searching for account history.`;
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(msg, err));
		}

		return promise;
	}
}

export default /* @ngInject */ (
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	LocalStorageService,
	InternalLinksService
) =>
	new PersonalDocumentsService(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		LocalStorageService,
		InternalLinksService
	);
